// extracted by mini-css-extract-plugin
export var desktop = "QuickSearchBar-module--desktop--ca201";
export var keepInPlace = "QuickSearchBar-module--keepInPlace--658cd";
export var mobile = "QuickSearchBar-module--mobile--f2e3a";